import {HTMLEditorProps} from 'lib/ui/form/HTMLEditor'
import HtmlNotificationHTMLEditor from 'lib/ui/form/HTMLEditor/HtmlNotificationHTMLEditor'
import React, {useCallback, useEffect} from 'react'

export default function PlainTextNotificationHTMLEditor(
  props: HTMLEditorProps,
) {
  const {data, onChange} = props
  const stripTags = (text: string) => text.replace(/(<([^>]+)>)/gi, '')

  const onChangeHtml = useCallback(
    (html: string) => onChange(stripTags(html)),
    [onChange],
  )

  const isHtml = useCallback((text: string) => /(<([^>]+)>)/.test(text), [])

  useEffect(() => {
    if (!isHtml(data)) {
      return
    }

    onChangeHtml(data)
  }, [data, onChangeHtml, isHtml])

  const html = isHtml(data) ? data : `<p>${data || ''}</p>`

  return (
    <HtmlNotificationHTMLEditor
      toolbar={['obvioVariable']}
      {...props}
      data={html}
      onChange={onChangeHtml}
    />
  )
}
